import React from "react";
import {SideBar} from "./sidebar";
import {Header} from "./header";
import {Onboarding} from "./onboarding";

export function DashboardBody({children}) {
    return (
        <div className="flex flex-col-reverse md:flex-row justify-start">
            <SideBar/>
            <div className="flex-1 md:max-h-screen  overflow-hidden pb-20">
                <Header/>
                <Onboarding/>
                <section className="flex-1 h-full overflow-y-auto overflow-x-hidden max-w-full">
                    {children}
                </section>
            </div>
        </div>
    )
}
